import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledCounterparty = styled.div`
  & + & {
    margin-top: 16px;
  }
`;
